import DocumentIndex from '@/views/fm/management/documents/Index'
import DocumentDetail from '@/views/fm/management/documents/Detail'
import DocumentDetail2 from '@/views/fm/management/documents2/Detail'
import DocumentTrigger from '@/views/fm/management/documents/Trigger'
import TriggerIndex from '@/views/fm/management/triggers/Index'
import TriggerDetail from '@/views/fm/management/triggers/Detail'
import MlTriggerIndex from '@/views/fm/management/mltriggers/Index'
import MlTriggerDetail from '@/views/fm/management/mltriggers/Detail'
import InvoiceRecognitionIndex from '@/views/fm/management/invoicerecognition/Index'
import InvoiceRecognitionDetail from '@/views/fm/management/invoicerecognition/InvoiceRecognitionDetail'
import TriggerMeldingenIndex from '@/views/fm/management/triggermeldingen/Index'
import FeedbackIndex from '@/views/fm/management/feedbacks/Index'
import DashboardIndex from '@/views/fm/management/dashboard/Index'

export default
    [
        {
            name: 'fmmanagement:index',
            path: '/fmmanagement',
            component: {
                template: '<div><router-view /></div>'
            },
            children: [
                {
                    name: `documents:index`,
                    path: `documents`,
                    component: DocumentIndex,
                    
                },
                {
                    name: `documents:detail`,
                    path: `documents/:documentId`,
                    component: DocumentDetail,
                    props: true
                },
                {
                    name: `documents2:detail`,
                    path: `documents2/:documentId`,
                    component: DocumentDetail2,
                    props: true
                },                
                {
                    name: `documents:trigger`,
                    path: `documents/:documentId/:triggerId`,
                    component: DocumentTrigger,
                    props: true
                }                       
            ]
        },
        {
            name:`fmmodule:index`,
            path:`/fmmodule`,
            component: {
                template: '<div><router-view /></div>'
            },
            children: [
                {
                    name: `invoicerecognitiondata:index`,
                    path: `invoicerecognition`,
                    component: InvoiceRecognitionIndex,
                    
                },
                {
                    name: `invoicerecognitiondata:detail`,
                    path: `invoicerecognition/:documentId`,
                    component: InvoiceRecognitionDetail
                },
                {
                    name: `triggers:index`,
                    path: `triggers`,
                    component: TriggerIndex,
                    
                },
                {
                    name: `triggers:detail`,
                    path: `triggers/:triggerId`,
                    component: TriggerDetail
                },   
                {
                    name: `mltriggers:index`,
                    path: `mltriggers`,
                    component: MlTriggerIndex,
                    
                },
                {
                    name: `mltriggers:detail`,
                    path: `mltriggers/:triggerId`,
                    component: MlTriggerDetail
                },                
                {
                    name: `triggermeldingen:index`,
                    path: `triggermeldingen`,
                    component: TriggerMeldingenIndex
                },    
                {
                    name: `feedback:index`,
                    path: `feedback`,
                    component: FeedbackIndex
                },
                {
                    name: `dashboard:index`,
                    path: `dashboard`,
                    component: DashboardIndex
                },        
            ]
        }        
    ]